const chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
const chnUnitSection = ['', '万', '亿', '万亿', '亿亿']
const chnUnitChar = ['', '十', '百', '千']

// 节内转换算法
function SectionToChinese(section) {
	var strIns = '',
		chnStr = '';
	var unitPos = 0;
	var zero = true;
	let ten = Math.floor(section / 100) > 0 ? false : true //超过100的要显示一十
	while (section > 0) {
		var v = section % 10;
		// console.log('section', section, unitPos, v, chnStr, strIns,ten)
		if (v === 0) {
			if (!zero) {
				zero = true;
				chnStr = chnNumChar[v] + chnStr;
			}
		} else {
			zero = false;
			if (unitPos == 1 && v < 2 && ten) {
				strIns = ''
			} else {
				strIns = chnNumChar[v];
			}
			strIns += chnUnitChar[unitPos];
			chnStr = strIns + chnStr;
		}
		unitPos++;
		section = Math.floor(section / 10);
	}
	return chnStr;
}
// 转换算法主函数
export function NumberToChinese(num) {
	var unitPos = 0;
	var strIns = '',
		chnStr = '';
	var needZero = false;

	if (num === 0) {
		return chnNumChar[0];
	}
	while (num > 0) {
		var section = num % 10000;
		if (needZero) {
			chnStr = chnNumChar[0] + chnStr;
		}
		strIns = SectionToChinese(section);
		strIns += (section !== 0) ? chnUnitSection[unitPos] : chnUnitSection[0];
		chnStr = strIns + chnStr;
		needZero = (section < 1000) && (section > 0);
		num = Math.floor(num / 10000);
		unitPos++;
	}
	return chnStr;
}

import {
	VUE_APP_RESOURCES_URL
} from '@/config'
const nowTime = new Date().getTime();

const imgs = (url) => {
	if (url && url.startsWith('/static')) {
		return VUE_APP_RESOURCES_URL + url;
	} else {
		return url
	}
	return url
};
export default imgs;
